import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { MAIN_URL } from "../../api/api";
import { getCouponImageStyles } from "../../constants/imageSizes";


const ImageWithHover = ({ icon, imageUrl }) => {
    const [hovered, setHovered] = useState(false);
    const [fallbackIndex, setFallbackIndex] = useState(0);

    const fallbackSources = useMemo(() => {
        if (!imageUrl) return [];

        const sources = [`${MAIN_URL}/images/${imageUrl}`];
        const jpgVersion = imageUrl.replace(/\.webp$/i, ".jpg");

        if (jpgVersion !== imageUrl) {
            sources.push(`${MAIN_URL}/images/${jpgVersion}`);
        }

        sources.push(`/images/${imageUrl}`);
        if (jpgVersion !== imageUrl) {
            sources.push(`/images/${jpgVersion}`);
        }

        return [...new Set(sources)];
    }, [imageUrl]);

    useEffect(() => {
        setFallbackIndex(0);
    }, [imageUrl]);

    const handleImageError = () => {
        setFallbackIndex((prev) => prev + 1);
    };

    return (
        <Box
            position="relative"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            display="flex"
            alignItems="center"
            gap={1}
        >
            {icon}
            {hovered && fallbackSources[fallbackIndex] && (
                <Box
                    position="absolute"
                    top={-20}
                    left={29}
                    zIndex={10}
                    bgcolor="white"
                    p={0}
                    boxShadow={3}
                    borderRadius={1}
                >
                    <img
                        src={fallbackSources[fallbackIndex]}
                        onError={handleImageError}
                        alt="Coupon"
                        style={getCouponImageStyles('HOVER')}
                    />
                </Box>
            )}
        </Box>
    );
};

export default ImageWithHover;
